/**
 * Owner decision, 11 Oct 2026: "We need to be able to mark irrelevant images for deletion, for example there is a photo of a
 * leaseholder." Removing moves the item to the recycle bin through the canonical move command; an administrator reviews it there.
 */
export const removalReasons=[
 {value:'Personal photo (privacy)',label:'Personal photo of a person (privacy)'},
 {value:'Not about a building',label:'Not about a building'},
 {value:'Duplicate',label:'Duplicate'},
 {value:'Other',label:'Other (say why)'},
] as const;
export type RemovalReason=typeof removalReasons[number]['value'];
/** A filed document, or an original still waiting in review (not yet filed). */
export type RemovableEntity='Document'|'Document intake item';
/** C-242; owner 25 Oct: short reasons for reversible removal. A stricter server override remains authoritative. */
export const otherReasonMinimum=3;

/** The move request, or null until a reason is chosen (and, for Other, explained). */
export function removalRequest(entityType:RemovableEntity,entityId:string,reason:RemovalReason|'',note:string,idempotencyKey:string){
 const text=note.trim();
 if(!reason||reason==='Other'&&text.length<otherReasonMinimum)return null;
 return {entityType,entityId,reasonCategory:reason,reason:text,idempotencyKey};
}
